/*
 * The list is a plain column; the table carries its own hairlines (the mockup's `.card.table-wrap`
 * and `.table`: 13px text, muted 12px column heads).
 */
.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.wrap {
  overflow-x: auto;
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.table {
  inline-size: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-13);
}

.table th {
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  text-align: start;
  white-space: nowrap;
}

.actionsHead {
  text-align: end;
}

.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
